import api from "../utils/axios";

export async function getSearchSuggestions(query, signal) {
    const response = await api.get(`/search/suggestions`, {
        params: { q: query },
        signal,
    });

    return {
        products: Array.isArray(response.data?.products)
            ? response.data.products
            : [],
        landingPage: Array.isArray(response.data?.landingPage)
            ? response.data.landingPage
            : [],
        relatedContent: Array.isArray(response.data?.relatedContent)
            ? response.data.relatedContent
            : [],
    };
}
